"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelRoundTopWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PanelRoundTopWidget = /** @class */ (function (_super) {
    __extends(PanelRoundTopWidget, _super);
    function PanelRoundTopWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PanelRoundTopWidget.prototype.render = function () {
        var panelTitle = this.getSetting("panelTitle", "");
        return (React.createElement("div", { className: "round-panel gutter-sides-remove" },
            React.createElement("div", { className: "panel-round-top d-inline-block tape-background ".concat(this.getSetting("cssClass", "")) },
                React.createElement("div", { className: "gutter-sides ".concat(this.getSetting("pageId", "")) },
                    panelTitle && React.createElement("h1", { className: "text-black" }, panelTitle),
                    this.renderChildren()))));
    };
    return PanelRoundTopWidget;
}(plugin_journey_1.GroupQuestionWidgetBase));
exports.PanelRoundTopWidget = PanelRoundTopWidget;
//# sourceMappingURL=PanelRoundTopWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/PanelRoundTopWidget.js
// module id = 3648
// module chunks = 0